/**
 * DeleteAccountCard, sheet 43 callout 10 (mission 10 WP16 T095; FR-017, FR-013's screen half; D.6, D.8, NF.9,
 * UC-04; style guide §7.1, §7.6).
 *
 * `deletionTitle` and `deletionBody`, and the Delete account danger button (`error-600`), which opens
 * DeleteAccountDialog and takes the focus back when it closes.
 */
import { useRef, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { copyText } from '@/lib/provisional-copy'

import { DeleteAccountDialog } from './DeleteAccountDialog'

export interface DeleteAccountCardProps {
  legalName: string | undefined
  /** `terms.fulfilment_days`. */
  days: number
  /** `terms.class2_years`. */
  years: number
  exportOpen: boolean
}

export function DeleteAccountCard({ legalName, days, years, exportOpen }: DeleteAccountCardProps) {
  const [open, setOpen] = useState(false)
  const opener = useRef<HTMLButtonElement>(null)
  return (
    <Card>
      <CardHeader>
        <CardTitle>{copyText('deletionTitle')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <p className="text-body-sm text-navy-700">{copyText('deletionBody')}</p>
        <div>
          <Button ref={opener} variant="destructive" onClick={() => setOpen(true)}>
            {copyText('deletionTitle')}
          </Button>
        </div>
      </CardContent>
      <DeleteAccountDialog
        open={open}
        onOpenChange={setOpen}
        legalName={legalName}
        days={days}
        years={years}
        exportOpen={exportOpen}
        returnFocus={opener}
      />
    </Card>
  )
}
